import { render, staticRenderFns } from "./TprCalendar.vue?vue&type=template&id=792ad3b6"
import script from "./TprCalendar.vue?vue&type=script&lang=js"
export * from "./TprCalendar.vue?vue&type=script&lang=js"
import style0 from "./TprCalendar.vue?vue&type=style&index=0&id=792ad3b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports